import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';

type Props = {
  classes: Object,
  className?: string,
  title?: string,
  children?: any,
};

type State = {};


class FriendInfoMessage extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    className: undefined,
    title: undefined,
    children: undefined,
    invalidConfig: [],
  };

  render() {
    const {
      classes,
      children,
      className,
      title,
    } = this.props;

    const style = {
      // 200 px for each child, but try do a min of 400 px (i.e. 2 children)
      width: `${Math.max(400, React.Children.count(children) * 190)}px`,
    };

    return (
      <div
        className={classNames(classes.infoMessage, className)}
        style={style}
      >
        <div className={classes.title}>{title}</div>
        <div className={classes.steps}>
          {children}
        </div>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    infoMessage: {
      display: 'flex',
      flexDirection: 'column',
      padding: 15,
      borderRadius: 8,
      maxWidth: '100%',
      border: {
        width: 2,
        style: 'solid',
        color: theme.color.basis6,
      },
      fontSmoothing: 'antialiased',
      margin: [0, 'auto'],
    },
    title: {
      color: theme.color.basis3,
      fontSize: 21,
      fontWeight: 600,
      textAlign: 'center',
      textTransform: 'uppercase',
      marginBottom: 10,
    },
    steps: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
      [theme.mediaQuery.tabletPortraitAndBelow]: {
        justifyContent: 'space-around',
      },
      [theme.mediaQuery.tabletLandscapeAndUp]: {
        '& > *:not(:last-child)': {
          marginRight: 75,
        },
      },
    },
  };
}

export default useSheet(applyStyles)(FriendInfoMessage);
